/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severityagreement1Inputs */

const en_severityagreement1 = /** @type {(inputs: Severityagreement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agreement`)
};

const pt_severityagreement1 = /** @type {(inputs: Severityagreement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acordo`)
};

/**
* | output |
* | --- |
* | "Agreement" |
*
* @param {Severityagreement1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severityagreement1 = /** @type {((inputs?: Severityagreement1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severityagreement1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severityagreement1(inputs)
	return pt_severityagreement1(inputs)
});
export { severityagreement1 as "severityAgreement" }